import React from 'react'

const RouterLinkModeContext = React.createContext(true)

export default RouterLinkModeContext
